/**
 * Copyright © Vaimo Group. All rights reserved.
 * See LICENSE_VAIMO.txt for license details.
 */

import $ from 'jquery';
import 'menuAim';

export default function () {
    let _$menu,
        _secondLevelInit,
        delay = 250,
        throttled = false,
        $menu,
        updateMenuHeight;

    /**
     * @returns {*|r.fn.init|n.fn.init|jQuery.fn.init|jQuery|HTMLElement}
     */
    function getMenu () {
        if (!_$menu) {
            _$menu = $('.main-navigation-wrapper');
        }

        return _$menu;
    }

    /**
     * Loads all menu images
     */
    function loadImages () {
        getMenu().find('.lazyloaded-images, img[data-above-the-fold="no"]').each(function () {
            this.src = this.dataset.src;
        });
    }

    /**
     * Activates dark content overlay when menu is active
     */
    function activateOverlay () {
        document.querySelector('.page-wrapper').classList.add('menu-overlay');
    }

    /**
     * Deactivates dark content overlay when menu is active
     */
    function deactivateOverlay () {
        document.querySelector('.page-wrapper').classList.remove('menu-overlay');
    }

    /**
     * @param {HTMLElement} item
     */
    function openSubmenu (item) {
        item.classList.add('open');
    }

    /**
     * @param {HTMLElement} item
     */
    function closeSubmenu (item) {
        item.classList.remove('open');
    }

    /**
     * @param {HTMLElement} row
     * @returns {$}
     */
    function getParentSubmenu (row) {
        return $(row).parents('.v-navigation__item--parent').find(' > .v-navigation__submenu').last();
    }

    /**
     * @param {HTMLElement} row
     */
    function expandSubmenu (row) {
        getParentSubmenu(row).addClass('expanded');
    }

    /**
     * @param {HTMLElement} row
     */
    function collapseSubmenu (row) {
        getParentSubmenu(row).removeClass('expanded');
    }

    /**
     * Handles L1 link interaction on desktop
     */
    function secondaryMenuAim () {
        let _currentlyActive;

        /**
         * @param {HTMLElement} row
         */
        function activateRow (row) {
            if (row.classList.contains('v-navigation__item--parent')) {
                _currentlyActive = row;
                openSubmenu(row);
                expandSubmenu(row);
            }
        }

        /**
         * @param {HTMLElement} row
         */
        function deactivateRow (row) {
            if (_currentlyActive === row) {
                _currentlyActive = null;
            }

            closeSubmenu(row);
            collapseSubmenu(row);
        }

        /**
         * Menu has been closed, handle overlays and cleanup
         *
         * @returns {boolean}
         */
        function exitMenu () {
            _currentlyActive = null;

            return true;
        }

        const possibleSubmenus =
            '.v-navigation__item--level0.v-navigation__item--parent .v-navigation__pseudo > .v-navigation__submenu';

        $(possibleSubmenus).each(function () {
            const $submenu = $(this);

            if ($submenu.children().first().hasClass('v-navigation__item')) {
                setTimeout(() => {
                    $submenu.menuAim({
                        activate: activateRow,
                        deactivate: deactivateRow,
                        exitMenu: exitMenu,
                        submenuDirection: "right"
                    });
                });
            }
        });
    }

    function primaryMenuAim () {
        let _currentlyActive,
            _deferTimeout,
            _lastDeactivated;

        /**
         * @private
         */
        function _toggleOverlay () {
            if (
                _currentlyActive &&
                _currentlyActive.classList &&
                _currentlyActive.classList.contains('v-navigation__item--parent')
            ) {
                activateOverlay();
            } else {
                deactivateOverlay();
            }
        }

        /**
         * Defer overlay handling for 50ms
         */
        function toggleOverlay () {
            if (_deferTimeout) {
                clearTimeout(_deferTimeout);
            }

            _deferTimeout = setTimeout(_toggleOverlay, 50);
        }

        /**
         * @param {HTMLElement} row
         */
        function activateRow (row) {
            _currentlyActive = row;
            toggleOverlay(row);
            loadImages();
            openSubmenu(row);

            if (!_secondLevelInit) {
                secondaryMenuAim();
                _secondLevelInit = true;
            }
        }

        /**
         * @param {HTMLElement} row
         */
        function deactivateRow (row) {
            if (_currentlyActive === row) {
                _currentlyActive = null;
            }

            toggleOverlay(row);
            closeSubmenu(row);
            _lastDeactivated = row;
        }

        /**
         * @param {HTMLElement} row
         */
        function enter (row) {
            if (!_currentlyActive) {
                activateRow(row);
            }
        }

        /**
         * L0 link is not longer active. Check after 50ms if we should deactivate it
         *
         * @param {HTMLElement} row
         */
        function exit (row) {
            if (_currentlyActive === row) {
                _currentlyActive = null;
            }

            toggleOverlay(row);

            setTimeout(function () {
                if (_lastDeactivated !== row) {
                    deactivateRow(row);
                }
            }, 50);
        }

        /**
         * Menu has been closed, handle overlays and cleanup
         *
         * @returns {boolean}
         */
        function exitMenu () {
            _currentlyActive = null;
            toggleOverlay();

            return true;
        }

        $('.v-navigation__main').menuAim({
            activate: activateRow,
            deactivate: deactivateRow,
            enter: enter,
            exit: exit,
            exitMenu: exitMenu,
            submenuDirection: "below"
        });
    }

    primaryMenuAim();

    $(function() {
        $menu = $('.v-navigation__item--level0>.v-navigation__submenu');

        if ($menu.length) {
            updateMenuHeight = function () {
                var height = '';

                if (window.innerWidth >= 1230) {
                    $menu.css('height', height);

                    setTimeout(function() {
                        height = $menu.height();
                        $menu.css('height', height);
                    });
                }

                $menu.css('height', height);
            };

            updateMenuHeight();

            window.addEventListener('resize', function() {
                if (!throttled) {
                    updateMenuHeight();
                    throttled = true;
                    setTimeout(function() {
                        throttled = false;
                    }, delay);
                }
            });
        }
    });

    // Destruct function
    return () => {
        $('.v-navigation__main').off().find('li').off();
    };
}
